import {BeaconPriorityCd} from '../';
import {EnumHelper} from './enum-helper';

export class BeaconPriorityCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in BeaconPriorityCd ) {
      this._values.push(BeaconPriorityCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): BeaconPriorityCd {

    for ( const obj in BeaconPriorityCd ) {
      if (BeaconPriorityCd[obj] === value){
        return BeaconPriorityCd[obj] as BeaconPriorityCd;
      }
    }
  }
}

const BeaconPriorityCdHelper = new BeaconPriorityCdHelperEnumHelperClass();
export default BeaconPriorityCdHelper;
